
import React from 'react'
import DisplayAdminMsg from '../dashboard/DisplayAdminMsg';


function SriyanshCardHeader({Title}) {


     return (

    
<>
{/* <div className="containerheader">
 <div className="input-group-header"> {Title}  </div>
 </div>
<div className=" containerheader blink">  
<span style={{ color: "yellow" }}>{<DisplayAdminMsg/>
      }</span> 
 </div> */}
{/* <div style={{marginTop: 4 + 'em'}}></div> */}

<div className="containerheader" >
 <div className="input-group-header"> {Title}  </div>
 </div>
<div className=" containerheader blink">  
<span style={{ color: "red" }}>{<DisplayAdminMsg/>
      }</span> 
 </div>
 {/* <div style={{marginTop: 2 + 'em'}}></div> */}
 </>
  )
}

export default SriyanshCardHeader